<template>
  <div class="confirm-email">
    <div class="background">
      <div>
        <b-button href="/login" class="btn-back" variant="link">
          <img src="@/assets/Confirmar-email/voltar.svg" class="svg" />
          Voltar
        </b-button>
      </div>
      <div>
        <b-container>
          <b-row>
            <b-card>
              <b-col lg="12" class="pb-4 d-flex justify-content-center">
                <img class="logo" src="@/assets/Logo-Seti/logo_seti.png" />
              </b-col>
              <b-alert v-model="showAlert" show variant="light" dismissible>
                <b-icon-exclamation-triangle-fill
                  variant="danger"
                  v-if="alertType == 'error'"
                />
                <b-icon v-else icon="check" variant="success" />
                {{ textAlert }}
              </b-alert>
              <div>
                <b-form @submit="trocarSenha">
                  <b-form-group
                    class="pb-3"
                    label="Informe o email cadastrado para recuperar a sua senha:"
                  >
                    <b-form-input
                      type="email"
                      required
                      v-model="$v.form.email.$model"
                      class="form-control"
                      placeholder
                      :state="validateState('email')"
                    ></b-form-input>
                  </b-form-group>

                  <ButtonFill
                    :showSpinner="showSpinner"
                    :disabled="$v.$invalid"
                    texto="Enviar"
                  />
                </b-form>
              </div>
            </b-card>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonFill from "@/components/Button-fill.vue";
import { ConfirmarEmail } from "@/services/api/Auth";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import fieldValidation from "@/utils/FieldValidation";
export default {
  mixins: [validationMixin, fieldValidation],
  components: {
    ButtonFill,
  },
  data() {
    return {
      showAlert: false,
      textAlert: "",
      alertType: "",
      showSpinner: false,
      form: {
        email: "",
      },
    };
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
  methods: {
    trocarSenha(evt) {
      evt.preventDefault();
      this.showSpinner = true;
      ConfirmarEmail(this.form)
        .then((res) => {
          console.log(res.data);
          this.showAlert = true;
          this.alertType = "sucess";
          this.textAlert = "Verifique sua caixa de entrada";
          this.showSpinner = false;
        })
        .catch((error) => {
          console.log(error);
          this.showAlert = true;
          this.alertType = "error";
          this.textAlert = error.response.data.error;
          this.showSpinner = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-email {
  background-color: #fcfcfc;
  font-family: Roboto;
  height: 100vh;
  margin: 0 auto;
}
.background {
  background-image: url("~@/assets/Login/background.svg");
  background-repeat: no-repeat;
  background-size: 100% 2%;
  background-position: top;
}
.svg {
  transform: rotate(90deg);
  width: 38px;
  height: 24px;
}
.btn-back {
  text-decoration: none;
  font-size: 17px;
  font-family: Roboto, sans-serif;
  color: #030303 !important;
  margin-left: 5%;
  padding-top: 50px;
}
.container {
  padding: 25px;
}
.card {
  border: 0px;
  background-color: #ffffff;
  box-shadow: 1px 4px 6px 2px #00000029;
  border-radius: 25px;
  margin: 0 auto;
  margin-bottom: 20px;
  margin-top: 100px;
  width: 24rem;
}
.logo {
  width: 250px;
  height: 137px;
}
.form-control {
  border: 1px solid #ee3824;
}
@media screen and (max-width: 260px) {
  .logo {
    width: 130px;
    height: 57px;
  }
}
</style>
